import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isQuizSingleChoice(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.QUIZ_SINGLE_CHOICE && typeof label === 'string' && typeof value === 'string';
}
function _formatQuizSingleChoice(_ref) {
  let {
    field,
    value
  } = _ref;
  if ((value == null ? void 0 : value.length) === 0) {
    return undefined;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatQuizSingleChoice(submission) {
  if (isQuizSingleChoice(submission)) {
    return _formatQuizSingleChoice(submission);
  }
  return undefined;
}
//# sourceMappingURL=quiz-single-choice-preview.js.map